<template>
	<div class="modal_container" @touchmove.prevent>
		<div class="content">
			<i class="iconfont icon-deletorerror close_icon" @click="this.close"></i>
			<div class="inner">
				<slot></slot>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: "Modal",
	methods: {
		close() {
			this.$emit("close");
		},
	},
};
</script>
<style lang="sass" scoped>
.modal_container
  position: fixed
  top: 0
  left: 0
  right: 0
  bottom: 0
  background-color: rgba(22, 34, 89, 0.75)
  z-index: 9999
  .close_icon
    position: absolute
    right: 0
    top: -3rem
    color: rgba(255, 255, 255, .6)
    cursor: pointer
  .content
    position: absolute
    top: 50%
    left: 50%
    transform: translate(-50%,-50%)
    border-radius: 0.6rem
    .icon-deletorerror
      font-size: 2.1rem
    .inner
      max-height: 80vh
      overflow-y: auto
      max-width: 100%
      border-radius: 4px;
@media screen and (max-width: 768px)
  .modal_container
    width: 100%
    .content
      width: 85%
      .inner
        .card 
          padding: 2rem 2rem
</style>